var map = {
	"./1.jpg": 9258,
	"./2.jpg": 4642,
	"./3.jpg": 2616,
	"./4.jpg": 9784,
	"./5.jpg": 8703,
	"./6.jpg": 7089,
	"./7.jpg": 7501,
	"./8.jpg": 219,
	"./9.jpg": 6829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4729;